import { Category, UserDecision } from "@usercentrics/cmp-browser-sdk";
import React, { PropsWithChildren } from "react";

export interface Decision extends UserDecision {
  categorySlug: string;
}

export type Status =
  | "initializing"
  | "initialized"
  | "initilizing_failed"
  | "updating"
  | "updated"
  | "updating_failed";

export const DecisionsContext = React.createContext<{
  decisions: {
    [id: string]: Decision;
  };
  updateDecision: (serviceId: string, status: boolean) => void;
}>({
  decisions: {},
  updateDecision: () => {},
});

export const DecisionsProvider: React.FC<
  PropsWithChildren<{ categories: Category[]; status: Status }>
> = ({ children, categories, status }) => {
  const [decisions, setDecisions] = React.useState({});

  React.useEffect(() => {
    if (status === "initializing") {
      return;
    }

    const newDecisions: {
      [id: string]: Decision;
    } = categories
      .flatMap((catg) =>
        catg.services.map((service) => ({
          serviceId: service.id,
          categorySlug: catg.slug,
          status: service.consent.status,
        }))
      )
      .reduce(
        (prevDecisions, currDecision) => ({
          ...prevDecisions,
          [currDecision.serviceId]: {
            ...currDecision,
          },
        }),
        {}
      );

    setDecisions(newDecisions);
  }, [categories, status]);

  const updateDecision = (serviceId: string, status: boolean) => {
    setDecisions((prevDecisions) => ({
      ...prevDecisions,
      [serviceId]: {
        ...prevDecisions[serviceId],
        status,
      },
    }));
  };

  const value = {
    decisions,
    updateDecision,
  };

  return (
    <DecisionsContext.Provider value={value}>
      {children}
    </DecisionsContext.Provider>
  );
};
